import "./CommonButton.scss";

interface ICommonButton {
  text: string;
  marginTop?: string;
  marginBottom?: string;
  onClick: () => void;
  padding?: string;
  fontSize?: string;
  blackVariant?: boolean;
}

const CommonButton = ({
  text,
  onClick,
  marginTop,
  marginBottom,
  padding,
  fontSize,
  blackVariant,
}: ICommonButton) => {
  return (
    <div
      onClick={onClick}
      className="commonButtonStyles"
      style={{
        marginTop: marginTop,
        marginBottom: marginBottom,
        padding: padding ? padding : "4px 40px",
        fontSize: fontSize ? fontSize : "20px",
        color: blackVariant ? "#000" : "#fff",
      }}>
      {text}
    </div>
  );
};

export default CommonButton;
